import { Button, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components'
import { Edit24Regular, Navigation24Regular } from '@fluentui/react-icons'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { createRestClient, RestSchemas } from '@/contexts/QueryProvider'
import { AddPipelineForm } from '@/ui/Forms/AddPipelineForm'
import { OverlayDrawerComponent } from '@/ui/OverlayDrawerComponent/OverlayDrawerComponent'

type MessagesPipelinesExistingPipeline = RestSchemas['Messages.Pipeline.ExistingPipeline']

export function PipelineCardActionsMenu({ pipeline }: { pipeline: MessagesPipelinesExistingPipeline }) {
  const queryClient = useQueryClient()
  const [drawerOpen, setDrawerOpen] = useState<'none' | 'editPipeline' | 'deletePipeline'>('none')

  const { applicationId } = pipeline

  const { getPipelineApiGetPipeline } = createRestClient()

  const invalidatePipelines = () => {
    getPipelineApiGetPipeline.invalidateQueries({ parameters: { path: { applicationId } } }, queryClient)
  }

  return (
    <div className="justify-self-end">
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <Button icon={<Navigation24Regular />} />
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem className="!items-center" onClick={() => setDrawerOpen('editPipeline')} icon={<Edit24Regular />}>
              Edit pipeline
            </MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>

      {/* Edit Pipeline Drawer */}
      <OverlayDrawerComponent
        open={drawerOpen === 'editPipeline'}
        size="medium"
        setOpen={(open) => setDrawerOpen(open ? 'editPipeline' : 'none')}
        title="Edit Pipeline"
        content={
          <AddPipelineForm
            mode="pipeline"
            applicationId={applicationId}
            selectedPipeline={pipeline}
            edit
            onSubmit={() => {
              setDrawerOpen('none')
              invalidatePipelines()
            }}
          />
        }
      />
    </div>
  )
}
